import React from 'react';
import SuccessIcon from './SuccessIcon';
import FailureIcon from './FailureIcon';

interface Props {
	success?: boolean
}

const FeedbackIcon: React.FC<Props> = ({ success }: Props) => {
	if (success === true)
		return <SuccessIcon />

	if (success === false)
		return <FailureIcon />
	
	return null
}

export default FeedbackIcon;